import { Fragment, PropsWithChildren } from 'react';
import styles from './panel-content-large.module.scss';

export interface PanelContentLargeProps {
	title: string;
	image: string;
}

export const PanelContentLarge = (props: PropsWithChildren<PanelContentLargeProps>) => {
	return (
		<div className="flex-container-horizontal flex-container-horizontal-break-1100">
			<div className="flex-size-same">
				<img src={props.image} title={props.title} />
			</div>
			<div className="flex-size-same">
				<h1 className={styles.title}>{props.title}</h1>
				{props.children}
			</div>
		</div>
	)
}